// @ts-nocheck
import { Toast as showToast } from "core/components/global/toast/toast";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import {
  MessageType,
  ConversationType,
  ConversationListResponse,
} from "../components/chat.type";
import { fetchBaseProxyUrl } from "core/utils/common";


const baseURL = fetchBaseProxyUrl({});

export async function getProvidersFromBackend(bearerToken: string) {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/api/provider_list`,
      headers: {
        "Content-Type": "application/json",
        authorization: bearerToken,
      },
    });
  
    if (response.status < 300) {
      // Get the raw response data
      const responseData = await response.data;

      // responseData =
    
      // const providers = responseData.map((provider) => ({
      //   name: provider.name,
      //   nice_name: provider.options.nice_name,
      // }));
    
      return responseData;
    } else {
      return(null)
    }
  } catch (error) {
    return(null) 
  }
}

export async function uploadFile(amsAccessToken, formData: string) {
  try {
    if (amsAccessToken) {
      const response = await fetch(`${baseURL}/api/file_chunk`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: amsAccessToken,
        },
        body: formData,
      });


      if (response.ok) {
        const data = await response.json();

        // const messageAi: MessageType = {
        //   id: data.chatid,
        //   user: "assistant",
        //   text: data.content,
        //   url: "",
        //   summary: data.content,
        //   title: "Malware",
        // };

        const messageAi: MessageType = {
          _id: data.chatid,
          chatid: data.chatid,
          role: "assistant",
          model: "",
          content: data.content,
          createdAt: "",
          updatedAt: "",
          loading: false,
        };

        return messageAi; // return the properly typed message
      } else {
        console.error("Error uploading file: 1");
        // Ensure the error message matches the MessageType structure
        return {
          _id: "0",
          chatid: "0",
          role: "assistant",
          model: "",
          content: "Error uploading file, please contact an administrator",
          createdAt: "",
          updatedAt: "",
          loading: false,
        } as MessageType;
      }
    } else {
      console.error("Error uploading file: 2");
      return {
        _id: "0",
        chatid: "0",
        role: "assistant",
        model: "",
        content: "",
        createdAt: "",
        updatedAt: "",
        loading: false,
      } as MessageType;
    }
  } catch (error) {
    console.error("Error uploading file: 3", error);
    // Return an object with the same shape as MessageType
    return {
      _id: "0",
      chatid: "0",
      role: "assistant",
      model: "",
      content: "",
      createdAt: "",
      updatedAt: "",
      loading: false,
    } as MessageType;
  }
}

/**
 * Delete a conversation history
 * @param conversationId Conversation History ID
 * @returns
 *
 */
export async function deleteConversationFromApi(
  amsAccessToken,
  conversationId: string
) {
  try {
    if (amsAccessToken) {
      const response = await axios.request({
        method: "DELETE",
        url: `${baseURL}/api/conversations`,
        headers: {
          Authorization: amsAccessToken,
          "Content-Type": "application/json",
        },
        data: {
          conversationId: conversationId,
        },
      });

      return response;
    } else {
      return null;
    }
  } catch (error) {
    showToast(`Failed to delete conversation: ${conversationId}` , "error");
    return null;
  }
}

/**
 * Update a conversation's name
 * @param conversationId Conversation History ID
 * @param conversationName Conversation History ID
 * @returns
 */
export async function updateConversationNameFromApi(
  amsAccessToken,
  conversationId: string,
  conversationName: string
) {
  try {
    if (amsAccessToken) {
      const response = await axios.request({
        method: "PUT",
        url: `${baseURL}/api/conversations/${conversationId}`,
        headers: {
          Authorization: amsAccessToken,
        },
        data: {
          conversationTitle: conversationName,
        },
      });

      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.error(`Error getting conversation: ${error}`);
    return null;
  }
}

function transformMessage(message) {
  if (message.role === "user") {
    return {
      id: message._id,
      role: "user",
      text: message.content,
      model: "",
      summary: "",
      title: "",
    };
  } else {
    return {
      id: message._id,
      role: "assistant",
      text: message.content,
      model: message.model || "",
      url: "",
      summary: message.content,
    };
  }


  // _id: string;
  // chatid: string;
  // role: "user" | "assistant";
  // model: string;
  // content: string;
  // createdAt: string;
  // updatedAt: string;
  // loading?: boolean;
  // Add additional conditions if needed for other roles
}

/**
 * Get all conversation histories via the /conversations API endpoint
 * @param conversationId [optional] Conversation history ID.
 * @returns
 */
export async function getConversationsFromApi(
  amsAccessToken,
  conversationId?: string
): Promise<ConversationType[]> {
  let url;
  if (conversationId) {
    url = `${baseURL}/api/conversations/${conversationId}`;
  } else {
    url = `${baseURL}/api/conversations`;
  }
  try {
    if (amsAccessToken) {
      // Make the request to the API server
      const response = await axios.request({
        method: "GET",
        url: url,
        headers: {
          authorization: amsAccessToken,
        },
      });

      if (response.status === 404) {
        // return an empty array if resource not found
        return [];
      } else {
        // Cast the output data appropriatly for TS
        const data = response.data as ConversationListResponse;

        // Return the list of conversations (a list)
        return data.conversations;
      }
    } else {
      // No token
      return [];
    }
  } catch (error) {
    console.error(`Error getting conversation: ${error}`);
    return [];
  }
}

/**
 * Get all a single conversation as a list of 1, via the /conversations API endpoint
 * @param conversationId [optional] Conversation history ID.
 * @returns
 */
export async function getConversationFromApi(
  amsAccessToken,
  conversationId?: string
): Promise<ConversationType[]> {
  const url = `${baseURL}/api/list_conversations/${conversationId}`;

  try {
    if (amsAccessToken) {
      // Make the request to the API server
      const response = await axios.request({
        method: "GET",
        url: url,
        headers: {
          authorization: amsAccessToken,
        },
      });

      if (response.status === 404) {
        // return an empty array if resource not found
        return [];
      } else {
        // Cast the output data appropriatly for TS
        const data = response.data as ConversationListResponse;

        const conversations = data.conversations.map((conversation) => ({
          ...conversation,
          messages: (conversation.messages ?? []).map(transformMessage) as any,
        }));

        // Return the list of conversations (a list)
        return conversations;
      }
    } else {
      // No token
      return [];
    }
  } catch (error) {
    console.error(`Error getting conversation: ${error}`);
    return [];
  }
}

/**
 * Sends a message to the LLM via the /message API endpoint.
 * @param payload Payload to send to LLM.
 * @returns Message response
 */
export async function sendPrompt(
  amsAccessToken: string,
  content: string,
  conversationId: string,
  activeModel: string
) {
  // This function returns a Message object, build it now
  let messageAssistant;

  const reqData = {
    content: content,
    model: activeModel,
    conversationid: conversationId,
    id: uuidv4(),
  };

  if (amsAccessToken) {
    // Make the request to the API server
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/api/message`,
      data: reqData,
      headers: {
        Authorization: amsAccessToken,
      },
    });

    // Extract the response body
    const data = response.data;

    if (typeof data.content === "string") {
      // messageAssistant = {
      //   id: data.chatid,
      //   user: "ai",
      //   text: data.content,
      //   title: "Malware",
      //   url: "",
      //   summary: data.content
      // }

      messageAssistant = {
        _id: data.chatid,
        chatid: data.chatid,
        role: "assistant",
        model: "",
        content: data.content,
        createdAt: "",
        updatedAt: "",
        loading: false,
      };
    } else if (typeof data.content === "object" && data.content !== null) {
      // TODO ask is this even still a thing because it is not in the new Swagger docs
      // What is URL?
      // What is title?
      // messageAssistant = {
      //   id: data.chatid,
      //   user: "ai",
      //   text: data.content.text,  // Assuming 'text' is a field on the object
      //   title: `${data.content.title} - ${data.content.vt_result}`,
      //   url: data.content.url,
      //   summary: data.content.text, // Assuming 'text' is a field on the object
      // }

      messageAssistant = {
        _id: data.chatid,
        chatid: data.chatid,
        role: "assistant",
        model: "",
        content: data.content.text,
        createdAt: "",
        updatedAt: "",
        loading: false,
      };
    }
  } else {
    showToast(
      "Problem fetching a token for this endpoint, please reach out to an administrator",
      "error"
    );
  }
  // Return the Message object
  return messageAssistant;
}

export const shareConversation = async (amsAccessToken: string, id: string) => {
  if(id) {
    try {
      const response = await axios.request({
        method: "POST",
        url: `${baseURL}/api/conversations/share`,
        data: { conversationID: id },
        headers: {
          Authorization: amsAccessToken,
        },
      });

      const data = response.data;
      
      let shareUrl;

      shareUrl = `${baseURL}/console/share/${data.share}`;

      return(shareUrl);
    } catch (error) {
      console.error("Error sharing conversation:", error.response?.data?.error || error.message);
      return(null)
    }
  }
}

export const fetchSharedConversation = async (token: string, share_uuid: string | undefined) => {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/api/conversations/share/${share_uuid}`,
      headers: {
        authorization: token,
      },
    });

    const data = await response.data;

    return data.conversations;
  } catch (error) {
    console.error("Error sharing conversation:", error.response?.data?.error || error.message);
    return(null)
  }
}

/**
 * Fetches a signed URL for a file from the API
 * @param {string} filePath - The path of the file in the bucket
 * @param {string} conversationId - The ID of the conversation
 * @returns {Promise<{signedUrl: string, expiresAt: string}>} - The signed URL and expiration date
 */
export const getSignedUrl = async (token: string, filePath: string, conversationId: string) => {
  try {
    // Get the token from localStorage
    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/api/conversations/signed-url`,
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      data: {
        filePath,
        conversationId,
      },
    });

    if (response.status < 300) {
      return {
        signedUrl: response.data.signedUrl,
        expiresAt: response.data.expiresAt,
      };
    } else {
      throw new Error(response.data.error || 'Failed to get signed URL');
    }
  } catch (error) {
    console.error("Error fetching signed URL:", error);
    throw error;
  }
}

/**
 * This function sends feedback to the backend API
 * @param message The current message
 * @param isLiked Is the message liked
 * @param userInput The active userinput
 * @param feedbackText The feedback given by the user
 */
export async function sendFeedbackToApi(
  amsAccessToken,
  conversationId,
  message,
  isNegative,
  feedbackText
) {
  try {
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/api/feedback`,
      data:  {
        conversationid: conversationId,
        model: message.model,
        chatid: message.chatid,
        negative: isNegative,
        note: feedbackText,
      },
      headers: {
        Authorization: amsAccessToken,
      },
    });

    if (response.status < 300) {
      return(true);
    } else {
      return(false);
    }
  } catch (error) {
    console.error("Error sharing conversation:", error.response?.data?.error || error.message);
    return(null)
  }
}
